import { CanDeactivateFn } from '@angular/router';

import { type StorageLocationStructurePage } from './storage-location-structure-page';

export const canLeaveStorageLocationStructure: CanDeactivateFn<StorageLocationStructurePage> = (
  page,
  _currentRoute,
  _currentState,
  nextState,
) => page.canDeactivate(nextState.url);
